import React from "react";
import CustomModal from "../../../../../components/CustomModal";
import Form from "./Form";
import { ICaixaGeral } from "../types/types";

export type CaixaMovementType = "deposito" | "retirada";

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  movementType: CaixaMovementType;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: ICaixaGeral;
}

const Create: React.FC<Props> = (props: Props) => {
  return (
    <CustomModal title={props.isEdit ? "Editar" : "Cadastrar"} onClose={props.onClear}>
      <Form
        isView={props.isView}
        selectedRow={props.selectedRow}
        movementType={props.movementType}
        onConfirm={props.onConfirm}
        isEdit={props.isEdit}
        onClose={props.onClear}
      />
    </CustomModal>
  );
};

export default Create;
